import ReactDOM from "react-dom/client";
import { App } from "./_sources/view-model-pattern/todo-vm/Root.tsx";
const mountElement = document.getElementById("todo-vm-demo");
// must be imported from the entrypoint
import "./todo-vm.css";

if (mountElement) {
  ReactDOM.createRoot(mountElement).render(<App />);
}
